import { render } from "./SurveyIntroduction.vue?vue&type=template&id=3f4cd7f0"
import script from "./SurveyIntroduction.vue?vue&type=script&lang=js"
export * from "./SurveyIntroduction.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__